export const shippingSpecTypes = {
  outboundSmallParcel: 'outboundSmallParcel',
  inbound: 'inbound',
  outbound: 'outbound',
};
